import { FunctionComponent } from 'react';

import { generatePluralStr } from './util';

interface Props {
    count: number;
    singular: string;
    plural?: string;
    showCount?: boolean;
}

const Pluralize: FunctionComponent<Props> = ({ count, singular, plural, showCount = true }) => {
    const output = generatePluralStr(count, singular, plural, showCount);
    return (<span>{output}</span>);
};

export default Pluralize;
